module.exports = __webpack_public_path__ + "01ea978f/img/revit-icon.5ff0d581.svg";